export const LOTTO_TOOLTIP_MESSAGES = {
    AUTHORIZED: 'Lotto is authorized for this store',
    NOT_AUTHORIZED: 'Lotto is not authorized for this store',
    POS_TYPE_NOT_SET: 'POS type is not set for this store',
    POS_TYPE_SET: 'POS type is set for this store',
    AUDIT_MISSING: 'Audit is missing for this day',
    LOTTO_DATA_NOT_AVAILABLE: 'There was an issue retrieving lotto data.',
    POS_DATA_NOT_AVAILABLE: 'There was an issue retrieving POS data.',
    DATA_PENDING: 'Lotto data is pending for this day',
    POS_DATA_PENDING: 'POS data is pending for this day',
} as const;